export default IconSwordOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-sword-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M11.938 7.937l3.062 -3.937h5v5l-3.928 3.055m-2.259 1.757l-2.813 2.188l-4 4l-3 -3l4 -4l2.19 -2.815" />
  <path d="M6.5 11.5l6 6" />
  <path d="M3 3l18 18" />
</svg>`;